package org.matthewo.math

fun Double.ifNaN(replacement: Double) = if (isNaN()) replacement else this

fun Double.ifNaN(replacement: Double?) = if (isNaN()) replacement else this
